
    const payType = ['Annually', 'Hourly'];

    export default {
        name: 'PayBandMenu',

        props: {
            value: {
                type: String,
                required: true,
            },

            variant: {
                type: String,
                default: 'primary',
                validator: value => ['primary', 'success'].includes(value),
            },

            hide: {
                type: String,
                default: '',
                validator: (value) => {
                    if (value) {
                        return payType.includes(value);
                    } else {
                        return true;
                    }
                },
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    'pay-band-menu',
                    this.getVariantClass,
                ];
            },

            getVariantClass() {
                return this.variant ? `pay-band-menu--${this.variant}` : '';
            },

            payTypeMenu() {
                return payType.filter(o => this.hide !== o);
            },
        },

        watch: {
            hideAnnually() {
                this.$emit('input', 'Hourly');
            },
        },

        methods: {
            select(item) {
                this.$emit('input', item);
            },
        },
    };
